/**
 * Debug page to test prospect fetching
 * Access at /debug-prospects
 */

import { useState, useEffect } from 'react';

export default function DebugProspects() {
  const [prospects, setProspects] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [rawResponse, setRawResponse] = useState<string>('');

  // Hardcoded campaign ID for testing
  const campaignId = 'e69b9310-db1e-46ec-8b12-2178c4a42bfb';

  useEffect(() => {
    const fetchProspects = async () => {
      const url = `/api/campaigns/${campaignId}/available-prospects`;
      console.log('Fetching:', url);

      try {
        const response = await fetch(url);
        const text = await response.text();
        setRawResponse(text);
        console.log('Raw response:', text);

        const data = JSON.parse(text);
        console.log('Parsed data:', data);

        setProspects(data.prospects || []);
      } catch (err: any) {
        console.error('Error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProspects();
  }, []);

  return (
    <div className="p-8 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Debug: Show All Contacts For This Client</h1>
      <p className="text-gray-600 mb-4">Campaign ID: {campaignId}</p>

      {loading && <p>Loading...</p>}

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          Error: {error}
        </div>
      )}

      <div className="mb-4">
        <h2 className="font-bold">Raw Response:</h2>
        <pre className="bg-gray-100 p-4 rounded overflow-auto text-sm">
          {rawResponse || 'No response yet'}
        </pre>
      </div>

      <div>
        <h2 className="font-bold mb-2">Prospects ({prospects.length}):</h2>
        {prospects.length === 0 ? (
          <p className="text-gray-500">No prospects found</p>
        ) : (
          <ul className="space-y-2">
            {prospects.map((p: any) => (
              <li key={p.id} className="bg-white border rounded p-3">
                <strong>{p.contact_first_name} {p.contact_last_name}</strong><br />
                {p.contact_email} - {p.company_name} - {p.contact_job_title}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
